import { JVDropdown } from "../../../shared/JVDropdown";
import { useForm } from 'react-hook-form';
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { JVInput } from "../../../shared/JVInput";
import { IPurchaseOrder } from "../../../models/PurchaseOrder";
import { useEffect, useState } from "react";
import { Fetch } from "../../../shared/Fetch";
import { IRequirementMast } from "../../../models/RequirementMast";
import { Button } from "primereact/button";
import { POConsultantRateHistory } from "./POConsultantRateHistory";
import { JVCheckbox } from "../../../shared/JVCheckbox";

interface Iprops {
    po: IPurchaseOrder,
    toast: any,
    activeIndex: number,
    setActiveIndex: (index: number) => void,
    setNeedtoReload: (reload: boolean) => void
}

export interface IModel2 {
    open: boolean,
    singleData: any
}

const schema = yup.object({
    // bRate: yup.number().required("B Rate is required").typeError("B Rate is required"),
    // sRate: yup.number().required("S Rate is required").typeError("S Rate is required"),
    //bRate: yup.number().nullable(),
    // sRate: yup.number().nullable(),
    mRate: yup.number().required("M Rate is required").typeError("M Rate is required"),
    branch_Name: yup.string().required("Branch is required").typeError("Branch is required"),
    brancPer: yup.number().required("This field is required").typeError("This field is required"),
    headOffPer: yup.number().required("This field is required").typeError("This field is required"),
    pV_Referal: yup.boolean().nullable(),

});

export const PositionInformation = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [label, setLabel] = useState("Agra");
    const [reqData, setReqData] = useState<IRequirementMast>();
    const branches = [
        { name: "Noida" },
        { name: "Agra" },
        { name: "Bhubaneswar" },
        { name: "Ranchi" },
        { name: "Meerut" },
        { name: "Varanasi" },
        { name: "Agra-Noida" },
        { name: "Varanasi-Noida" },
        { name: "Varanasi-Agra" },
    ];

    const [modal2, setModal2] = useState({ singleData: {}, open: false, load: false } as any);
    const hideDialog2 = () => {
        setModal2({ singleData: {}, open: false, load: false });
    };

    const { control, handleSubmit, formState: { errors }, watch, setValue } = useForm<IPurchaseOrder>({
        resolver: yupResolver(schema),
        defaultValues: {
            bRate: props.po.bRate,
            sRate: props.po.sRate,
            mRate: props.po.mRate,
            branch_Name: props.po.branch_Name,
            brancPer: props.po.brancPer,
            headOffPer: props.po.headOffPer,
            pV_Referal: props.po.pV_Referal || false,
            // pV_Referal:isLinkUser
        },
        shouldFocusError: false
    });
    // console.log(props.po.sRate)
    const isLinkUser = watch("pV_Referal");
    const methodSetLabel = (branch: string) => {
        if (branch === "Noida") setLabel("None");
        else if (branch === "Agra") setLabel("Agra");
        else if (branch === "Varanasi") setLabel("Varanasi");
        else if (branch === "Agra-Noida") setLabel("Agra");
        else if (branch === "Varanasi-Noida") setLabel("Varanasi");
        else if (branch === "Varanasi-Agra") setLabel("Varanasi-Agra");
    }
    const setLabelValue = (branch: string) => {
        if (branch === "Noida") {
            setValue("brancPer", 0);
            setValue("headOffPer", 100);
        }
        else if (branch === "Agra") {
            setValue("brancPer", 70);
            setValue("headOffPer", 30);
        }
        else if (branch === "Varanasi") {
            setValue("brancPer", 70);
            setValue("headOffPer", 30);
        }
        else if (branch === "Agra-Noida") {
            setValue("brancPer", 50);
            setValue("headOffPer", 50);
        }
        else if (branch === "Varanasi-Noida") {
            setValue("brancPer", 50);
            setValue("headOffPer", 50);
        }
        else if (branch === "Varanasi-Agra") {
            setValue("brancPer", 70);
            setValue("headOffPer", 30);
        }
    }

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "branch_Name" && value.branch_Name) {
                methodSetLabel(value.branch_Name);
                setLabelValue(value.branch_Name);
            }
            if (name === "bRate" || name === "sRate") {
                if ((value.bRate != 0 && value.bRate != null) && (value.sRate != 0 && value.sRate != null)) {
                    control._formValues.mRate = control._formValues.sRate - value.bRate;
                    setValue('mRate', control._formValues.sRate - value.bRate);
                }
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    const loadReqData = async () => {
        const response = await Fetch("Requirement_MAST/byId", "GET", null, `req_id=${props.po.req_ID}`, props.toast);
        if (response) {
            const data: IRequirementMast = await response.json();
            setReqData(data);
        }
    }
    useEffect(() => {
        if (props.po.req_ID) loadReqData();
        if (props.po.branch_Name) methodSetLabel(props.po.branch_Name);
    }, [props.po.req_ID, props.po.branch_Name]);

    const saveToDB = async (body: IPurchaseOrder) => {
        setLoading(true);
        body.pO_ID = props.po.pO_ID;
        const response = await Fetch("vwPODetails/details", "POST", body, `tb=${1}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', content: "Saved Successfully" });
            props.setActiveIndex(props.activeIndex + 1);
            props.setNeedtoReload(true);
        }
        setLoading(false);
    }
    function onSubmit(data: any) {
        console.log(data);
        const errors: Record<string, string> = {};

        if (data.sRate == null || data.sRate == ""  ) {
            data.sRate = null
        }
        if(data.bRate == null || data.bRate == ""){
            data.bRate = null
        }
        if (data.pV_Referal == false || data.pV_Referal == null) {
            console.log("1234")

            if (data.bRate == null) {
                props.toast.current.show({ severity: 'error', content: "B Rate is required" });
                errors.bRate = "B Rate is required";
                // console.log(errors.bRate);
            }
            else if (data.sRate == null || data.sRate == "") {
                data.sRate = null
                props.toast.current.show({ severity: 'error', content: "S Rate is required" });
                errors.sRate = "B Rate is required";
            } else {
                saveToDB(data);

            }


        } else {
            saveToDB(data);
            console.log("dd")


        }
    }

    const ShowPOConsultantRateHistory = () => {
        setModal2({ singleData: { ...props.po }, open: true, load: true });
    }

    return (
        <div className='w-11 m-auto mt-2'>
            <div className="grid formgrid">
                <h5 className="field col-12 md:col-4 mt-4">Job Title : <span className='text-600 font-light'>{reqData?.req_Job_Title}</span></h5>
                <h5 className="field col-12 md:col-4">Duration : <span className='text-600 font-light'>{reqData?.req_Duration}</span></h5>
                <h5 className="field col-12 md:col-4">Location : <span className='text-600 font-light'>{reqData?.city_Name}, {reqData?.state_Name}</span></h5>

                <h5 className="field col-12 md:col-4">Req.Type : <span className='text-600 font-light'>{reqData?.req_Category_Name}</span></h5>
                <h5 className="field col-12 md:col-4">Term : <span className='text-600 font-light'>{reqData?.req_Term}</span></h5>
                <h5 className="field col-12 md:col-4">Client : <span className='text-600 font-light'>{reqData?.vendor_Company_Name}</span></h5>
            </div>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mt-3">
                {!isLinkUser && <JVInput required column={3} label="Buying Rate" control={control} name="bRate" error={errors.bRate?.message} />}
                {!isLinkUser && <JVInput required column={3} label="Submission Rate" control={control} name="sRate" error={errors.sRate?.message} />}
                {isLinkUser && <JVInput column={3} label="Buying Rate" control={control} name="bRate" />}
                {isLinkUser && <JVInput column={3} label="Submission Rate" control={control} name="sRate" />}
                <JVInput required column={3} label="Margin" control={control} name="mRate" error={errors.mRate?.message} disabled={!isLinkUser} />
                {/* <JVCheckbox column={2} label="" control={control} name="pV_Referal" /> */}

                <JVDropdown required column={3} label="Branch" control={control} name="branch_Name" options={branches} optionLabel="name" optionValue="name" placeholder="Select Branch" error={errors.branch_Name?.message} />
                <JVInput required column={3} label={label} control={control} name="brancPer" error={errors.brancPer?.message} />
                <JVInput required column={3} label="Noida" control={control} name="headOffPer" error={errors.headOffPer?.message} />
                <div className="col-6 md:col-6 flex gap-4 mt-3">
                    <label htmlFor="">&nbsp;</label>
                    <Button loading={loading} type="submit" label='SAVE & NEXT'></Button>
                    <Button type="button" icon="pi pi-history" loading={loading} onClick={ShowPOConsultantRateHistory} tooltip="PO Consultant Rate History" className="p-button-outlined" ></Button>
                    <JVCheckbox column={4} label="PV Referral" control={control} name="pV_Referal" />

                </div>
            </form>
            <POConsultantRateHistory singleData={modal2.singleData} open={modal2.open} load={modal2.load} hideDialog={hideDialog2} toast={props.toast} ></POConsultantRateHistory>
        </div>
    );
}
